import type { UploadedFile } from 'models';
import type { AttahcmentsInputUploadFile } from '../AttachmentsInput';

export const generateAttachmentsInputFileListItem = (file: UploadedFile): AttahcmentsInputUploadFile => ({
  fileName: file.filename,
  name: file.filename,
  percent: 100,
  response: file,
  size: file.byteSize,
  status: 'done',
  type: file.contentType,
  uid: file.id,
  url: file.url,
});
